import { useState } from 'react';

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-background-50/95 backdrop-blur-md border-b border-background-200/60">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-14 md:h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <div className="w-8 h-8 md:w-9 md:h-9 rounded-lg bg-primary-500 flex items-center justify-center">
              <i className="ri-play-fill text-background-50 text-lg md:text-xl"></i>
            </div>
            <span className="font-heading text-lg md:text-xl font-bold text-foreground-950">91免费视频</span>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8">
            <Link to="/" className="text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">
              首页
            </Link>
            <div className="relative group">
              <Link to="/category/entertainment" className="text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer flex items-center gap-1">
                分类
                <i className="ri-arrow-down-s-line text-xs"></i>
              </Link>
              <div className="absolute top-full left-1/2 -translate-x-1/2 pt-3 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
                <div className="bg-background-50 border border-background-200/70 rounded-lg shadow-lg py-2 w-44">
                  {["娱乐综艺","教育学习","科技数码","生活美食","体育竞技","音乐舞蹈"].map((c) => (
                    <Link
                      key={c}
                      to={`/category/${c === "娱乐综艺" ? "entertainment" : c === "教育学习" ? "education" : c === "科技数码" ? "technology" : c === "生活美食" ? "lifestyle" : c === "体育竞技" ? "sports" : "music"}`}
                      className="block px-4 py-2 text-sm text-foreground-700 hover:bg-background-100 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      {c}
                    </Link>
                  ))}
                  <Link to="/category/entertainment" className="block px-4 py-2 text-sm text-primary-500 font-medium border-t border-background-200/60 mt-1 pt-2 hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer">
                    查看全部分类 →
                  </Link>
                </div>
              </div>
            </div>
            <Link to="/about" className="text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">
              关于我们
            </Link>
          </div>

          {/* Right Actions */}
          <div className="flex items-center gap-3">
            {/* Search */}
            <div className="relative">
              <button
                onClick={() => setSearchOpen(!searchOpen)}
                className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-background-100 transition-colors cursor-pointer"
                aria-label="搜索"
              >
                <i className="ri-search-line text-foreground-700 text-lg"></i>
              </button>
              {searchOpen && (
                <div className="absolute right-0 top-full mt-2 w-64 md:w-80">
                  <div className="bg-background-50 border border-background-200/70 rounded-lg shadow-lg p-2">
                    <div className="relative">
                      <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
                      <input
                        type="text"
                        placeholder="搜索视频..."
                        className="w-full pl-9 pr-4 py-2 text-sm rounded-md bg-background-100 border border-background-200/60 text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                        autoFocus
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setMobileOpen(!mobileOpen)}
              className="w-8 h-8 flex md:hidden items-center justify-center rounded-full hover:bg-background-100 transition-colors cursor-pointer"
              aria-label="菜单"
            >
              <i className={`${mobileOpen ? 'ri-close-line' : 'ri-menu-line'} text-foreground-700 text-lg`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileOpen && (
          <div className="md:hidden border-t border-background-200/60 py-4">
            <div className="flex flex-col gap-1">
              <Link to="/" onClick={() => setMobileOpen(false)} className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer">
                首页
              </Link>
              <Link to="/category/entertainment" onClick={() => setMobileOpen(false)} className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer">
                全部分类
              </Link>
              <Link to="/about" onClick={() => setMobileOpen(false)} className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer">
                关于我们
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}